(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/eurojackpot.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/eurojackpot.js');

'use strict';

var _svs$numbergames;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const EUROJACKPOT = {
  productId: (_svs$numbergames = svs.numbergames) === null || _svs$numbergames === void 0 || (_svs$numbergames = _svs$numbergames.productMapping) === null || _svs$numbergames === void 0 ? void 0 : _svs$numbergames.CONSTANTS.EUROJACKPOT,
  rowPrice: 25,
  rowPriceMultipliers: [1],
  numbersMaxValue: 50,
  numbersMaxLength: 5,
  numbersExtraMaxValue: 12,
  numbersExtraMaxLength: 2,
  maxNumberOfRows: 12,
  huxfluxManual: true,
  winConditions: [{
    numbers: 3
  }, {
    numbers: 2,
    numbersExtra: 1
  }, {
    numbers: 1,
    numbersExtra: 2
  }],
  hasSubscription: true,
  possibleDrawCounts: [{
    value: '1',
    label: '1 V'
  }, {
    value: '2',
    label: '2 V'
  }, {
    value: '3',
    label: '3 V'
  }, {
    value: '4',
    label: '4 V'
  }, {
    value: '5',
    label: '5 V'
  }, {
    value: '6',
    label: '6 V'
  }, {
    value: '7',
    label: '7 V'
  }, {
    value: '8',
    label: '8 V'
  }, {
    value: '9',
    label: '9 V'
  }, {
    value: '10',
    label: '10 V'
  }],
  PACKAGES: {
    100: {
      rows: 4
    },
    200: {
      rows: 8
    },
    400: {
      rows: 16
    }
  },
  SYSTEM: {
    LIMITS: {
      NUMBERS: {
        minRowLength: 5,
        maxRowLength: 13,
        combinationMinLength: {
          2: 6,
          3: 5,
          4: 5,
          5: 5,
          6: 5,
          7: 5,
          8: 5,
          9: 5,
          10: 5,
          11: 5,
          12: 5
        },
        combinationMaxLength: {
          2: 13,
          3: 11,
          4: 9,
          5: 9,
          6: 8,
          7: 8,
          8: 7,
          9: 7,
          10: 7,
          11: 7,
          12: 6
        }
      },
      NUMBERS_EXTRA: {
        minRowLength: 2,
        maxRowLength: 12,
        combinationMinLength: {
          5: 3,
          6: 2,
          7: 2,
          8: 2,
          9: 2,
          10: 2,
          11: 2,
          12: 2,
          13: 2
        },
        combinationMaxLength: {
          5: 12,
          6: 12,
          7: 11,
          8: 7,
          9: 5,
          10: 3,
          11: 3,
          12: 2,
          13: 2
        }
      }
    }
  }
};

if (!svs.isServer && !svs.core.detect.feature('ft-new-drawcount-eurojackpot')) {
  EUROJACKPOT.possibleDrawCounts = [{
    value: '1',
    label: '1 V'
  }, {
    value: '5',
    label: '5 V'
  }, {
    value: '10',
    label: '10 V'
  }];
}
const EUROJACKPOT_SELFSERVICE = _objectSpread(_objectSpread({}, EUROJACKPOT), {}, {
  possibleDrawCounts: [{
    value: '1',
    label: '1 V'
  }, {
    value: '5',
    label: '5 V'
  }, {
    value: '10',
    label: '10 V'
  }]
});
if (svs.isServer) {
  module.exports = {
    EUROJACKPOT,
    EUROJACKPOT_SELFSERVICE
  };
} else {
  svs.numbergames.rules.EUROJACKPOT = EUROJACKPOT;
  svs.numbergames.rules.EUROJACKPOT_SELFSERVICE = EUROJACKPOT_SELFSERVICE;
}

 })(window);